// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__QkGFJ","closeModalIcon":"PopUpModal_closeModalIcon__iNG6T"};